import {Column} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import IntegrityRoleGrid from '../../../../components/UserRole';
import IntegrityRequirementGrid from '../../../requirement/component/IntegrityRequirementGrid';
import useLoadRequirementById from '../../../requirement/hooks/useLoadRequirementById';

const RequirementGrid = ({id}: any) => {
  const loadRequirements = useLoadRequirementById(id);

  return (
    <IntegrityRoleGrid
      dataSource={loadRequirements}
      id={['iD_Course', 'iD_Sector', 'iD_Profile']}
      integrityGrid={IntegrityRequirementGrid}
      integrityId={['ID_Course', 'ID_Sector', 'ID_Profile']}
      integrityName={'Requirement'}
      allowActions={false}
    >
      <Column
        caption={i18n2._('#Curso')}
        visible={false}
        dataField="iD_Course"
      />
      <Column
        caption={i18n2._('#Perfil')}
        visible={false}
        dataField="iD_Profile"
      />
      <Column
        caption={i18n2._('#Sector')}
        visible={false}
        dataField="iD_Sector"
      />
      <Column caption={i18n2._('Sector')} dataField="sector_Name" />
      <Column caption={i18n2._('Perfil')} dataField="profile_Name" />
      <Column caption={i18n2._('Curso')} dataField="course_Name" />
      <Column
        caption={i18n2._('Fecha de Requerimiento')}
        dataField="req_Date"
      />
      <Column caption={i18n2._('Version')} dataField="version" />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        defaultSortOrder={'desc'}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default RequirementGrid;
